import type { NavItem } from '@/data/menu';

export type SearchableNavEntry = {
    id: string;
    label: string;
    href: string;
    target?: string | null;
    groupLabel: string | null;
    keywords: string;
};

function isNavigableHref(href: string | null | undefined): href is string {
    if (!href?.trim()) {
        return false;
    }
    const raw = href.trim();
    return (
        raw !== '#' &&
        !raw.startsWith('javascript:') &&
        !raw.startsWith('mailto:') &&
        !raw.startsWith('tel:')
    );
}

function normalizeSearchText(value: string): string {
    return value
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim();
}

/** Achata o menu compartilhado em entradas navegáveis para a busca global. */
export function flattenMenuForSearch(menu: NavItem[]): SearchableNavEntry[] {
    const entries: SearchableNavEntry[] = [];

    for (const item of menu) {
        const children = item.children?.filter((child) =>
            isNavigableHref(child.href),
        );

        if (children?.length) {
            for (const child of children) {
                const groupLabel = item.label;
                entries.push({
                    id: child.id,
                    label: child.label,
                    href: child.href,
                    groupLabel,
                    keywords: normalizeSearchText(
                        `${child.label} ${groupLabel} ${child.href}`,
                    ),
                });
            }
            continue;
        }

        if (isNavigableHref(item.href)) {
            entries.push({
                id: item.id,
                label: item.label,
                href: item.href,
                groupLabel: null,
                keywords: normalizeSearchText(`${item.label} ${item.href}`),
            });
        }
    }

    return entries;
}

export function filterSearchEntries(
    entries: SearchableNavEntry[],
    query: string,
): SearchableNavEntry[] {
    const q = normalizeSearchText(query);
    if (!q) {
        return entries;
    }

    return entries.filter((entry) => entry.keywords.includes(q));
}
